import React from 'react';
import { Row, Col, Divider, Button } from 'antd';
import { formatPrice, gaEvent } from '../../../utils/utils';
import { blockTitle, summaryListItemTitle } from './styles';
import { disclaimerStyle } from '../../UI/Disclaimer';
import { SummaryProps } from '../../../types/summary';
import ProductList from './Summary/ProductList';
import LinesList from './Summary/LinesList';

const Summary: React.FC<SummaryProps> = ({ data, url }) => {
  if (!data) return null;

  const onClickCTA = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    gaEvent('planView', 'click:configure', 'configure');
    if (url) {
      window.open(url, '_blank');
    }
  };

  return (
    <Row style={{ padding: '0 16px' }}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <span style={blockTitle}>Estimate Details</span>
          </Col>
        </Row>
        <Row justify="space-around" align="middle">
          {data?.preconstruction && (
            <LinesList
              list={data.preconstruction}
              showPrice={false}
              disclaimer="Prices vary depending on location."
            />
          )}
          {data?.products && (
            <Col span={24} md={20}>
              {data.products.map((product, index) => (
                <Row gutter={[16, 16]} key={`category-${index}`}>
                  <Col span={24}>
                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{product.title}</span>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[16, 16]}>
                      <ProductList list={product.data} />
                    </Row>
                  </Col>
                </Row>
              ))}
            </Col>
          )}
          <Col span={24} md={20}>
            <Row justify="center" align="middle">
              <Col>
                <Button
                  size="large"
                  style={{
                    background: '#EE8865',
                    fontSize: '18px',
                    lineHeight: '21px',
                    textAlign: 'center',
                    width: '300px',
                    height: '60px',
                    border: '1px solid #EE8865',
                    boxSizing: 'border-box',
                    color: '#000000',
                    margin: '1em',
                  }}
                  onClick={onClickCTA}>
                  Configure
                </Button>
              </Col>
            </Row>
          </Col>
          {data?.materials && <LinesList list={data.materials} />}
          {data?.labor && (
            <>
              <LinesList list={data.labor} showTotal={false} showPrice={false} />
              <Col span={24} md={20}>
                <Divider style={{ margin: 0 }} />
                <Row justify="space-between">
                  <span style={summaryListItemTitle}>Total Labor starting from</span>
                  <span style={summaryListItemTitle}>
                    ${formatPrice(data.price?.labor.min || 0)}*
                  </span>
                  <span style={{ ...disclaimerStyle, textAlign: 'left' }}>
                    *Prices for labor differ dramatically depending on the location, availability,
                    and qualifications of the skilled workers. Please discuss with your local
                    professional to determine the cost of your project.
                  </span>
                </Row>
              </Col>
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Summary;
